export function secondsToHHMMSS(seconds) {
  const date = new Date(0);
  date.setSeconds(seconds);
  return date.toLocaleTimeString([], {
    minute: "2-digit",
    second: "2-digit",
  });
}
